<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">选择部门</div>
                    <div
                        class="xc-modal-close"
                        @click="layerClose"
                    ></div>
                </div>
                <div class="xc-modal-body">
                    <div class="tree" v-if="list.length">
                        <xc-tree
                            :data.sync="list"
                            label="label"
                            @expanded="toggleFunc"
                            @selected="selectFunc"
                            @checked="checkFunc"
                            @updated="updateData"
                            @init="hasInit"
                            show-checkbox
                            :expand="-1"
                        ></xc-tree>
                    </div>
                </div>
                <div class="xc-modal-footer xc-flex-center">
                    <div class="xc-btn-group">
                        <button
                            class="xc-btn xc-btn-default"
                            @click="layerClose"
                        >取消</button>
                        <button type="button" class="xc-btn xc-btn-primary" @click="select">确定</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import myLayerImport from '@/libs/myLayer';
    import {getTree} from "@/api/department"

    myLayerImport();

    export default {
        name: 'DepartmentSelect',
        data() {
            return {
                // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
                channel: 0,
                list:[],
                checked:[],
                currentId:""
            }
        },
        computed:{

        },
        created(){
            var _this=this;
            var currentId=this.$route.query.currentId;
            if(currentId){
                this.currentId=parseInt(currentId);
            }
            getTree().then(function (success) {
                if(_this.currentId){
                    var current=_this.initData(success.data,_this.currentId);
                    _this.handleData(current)
                }
                _this.list=success.data;
            }).catch(function (error) {
                _this.$message.error("出了一点问题");
            })
        },
        methods: {
            //寻找departmetnId为currentId的对象
            initData(data,currentId){
                if(data.length){
                    for(let x of data){
                        if(x.departmentId==currentId){
                            return x;
                        }
                        var child=this.initData(x.children,currentId);
                        if(child){
                            return child
                        }
                    }
                }else {
                    return false;
                }
            },
            //设置disabled
            handleData(data){
                data.disabled=true;
                if(data.children.length){
                    for(let x of data.children){
                        this.handleData(x)
                    }
                }
            },
            layerClose() {
                var index = parent.layer.getFrameIndex(window.name);
                parent.layer.close(index);
            },
            select:function () {
                if(!this.checked.length){
                    this.$message.error("请选择数据");
                    return;
                }
                var name="";
                var departmentId="";
                if(this.checked.length){
                     name=this.checked[0].label;
                     departmentId=this.checked[0].departmentId;
                }
                parent.init(name,departmentId);
                this.layerClose()
            },
            //  树形插件折叠的回调
            toggleFunc: function (data) {
            },
            //    树形点击文字的回调
            selectFunc: function (data) {
            },
            //    点击选择框的回调
            checkFunc: function (data) {
                this.checked=data.checked;
            },
            //    更新父组件的数据
            updateData: function (data) {
            },
            //    初始化完成后的回调
            hasInit: function (data) {
                this.checked=data.checked;
            }
        },
    }
</script>

<style lang="scss" scoped>


</style>
